import PropTypes from 'prop-types';
// material
import { Paper, Typography } from '@mui/material';
import { useTranslation, Trans } from 'react-i18next';

// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  searchQuery: PropTypes.string
};

export default function SearchNotFound({ searchQuery = '', ...other }) {
  const { t } = useTranslation();
  return (
    <Paper {...other}>
      <Typography gutterBottom align="center" variant="subtitle1">
        {t('SearchNotFound.title')}
      </Typography>
      <Typography variant="body2" align="center">
        <Trans
          i18nKey="SearchNotFound.text"
          values={{ query: searchQuery }}
          components={[
            <strong key="q1">&quot;</strong>,
            <strong key="q2">&quot;</strong>
          ]}
        />
      </Typography>
    </Paper>
  );
}
